<script setup>

import { ref } from "vue";
import CartaoListaDeJobs from "./CartaoListaDeJobs/CartaoListaDeJobs.vue";
import ModalVisualizarParcelasDeJob from "./ModalVisualizarParcelasDeJob/ModalVisualizarParcelasDeJob.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//================= Visualizando Parcelas do Job ===================//
//==================================================================//

const visualizandoParcelasDoJob = ref(false);

//==================================================================//
//====================== Controles Desativados =====================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//============================= Dados ==============================//
//==================================================================//

const dados = ref([]);

//==================================================================//
//========================-===== Dado ==============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//======================== Recarrega Dados =========================//
//==================================================================//

const recarregaDados = ref(false);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update;

};

//==================================================================//
//======================= Altera Dados =============================//
//==================================================================//

const alteraDados = (update=[])=>{

    // Armazena os Dados
    dados.value = update;

    // Se não há Dado Selecionado interrompa não possiga.
    if(!dado?.value?.id){
        return;
    }

    // Se há Dado Selecionado atualize nele.
    let dadoAtualizado = dados.value.find(({id})=> id == dado.value.id);
    alteraDado(dadoAtualizado);

};

//==================================================================//
//====================== Altera Dado ===============================//
//==================================================================//

const alteraDado = (update={})=>{

    dado.value = update

};

//==================================================================//
//==================== Altera Recarrega Dados ======================//
//==================================================================//

const alteraRecarregaDados = (update = false)=>{

    recarregaDados.value = update;

};

//==================================================================//
//============== Altera Visualizando Parcelas do Job ===============//
//==================================================================//

const alteraVisualizandoParcelasDoJob = (update={})=>{

    visualizandoParcelasDoJob.value = update?.status || false;
    alteraDado(update?.dado || {});

};

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Parcelas dos Jobs
        </h2>

        <CartaoListaDeJobs
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :visualizandoParcelasDoJob="visualizandoParcelasDoJob"
            :recarregaDados="recarregaDados"
            :dados="dados"
            @update:alteraVisualizandoParcelasDoJob="alteraVisualizandoParcelasDoJob"
            @update:alteraDados="alteraDados"
            @update:alteraRecarregaDados="alteraRecarregaDados"
        ></CartaoListaDeJobs>
        
        <ModalVisualizarParcelasDeJob
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :modalStatus="visualizandoParcelasDoJob"
            :recarregaDados="recarregaDados"
            :controlesDesativados="controlesDesativados"
            :dadoOriginal="dado"
            @update:alteraModal="alteraVisualizandoParcelasDoJob"
            @update:alteraRecarregaDados="alteraRecarregaDados"
            @update:alteraControlesDesativados="alteraControlesDesativados"
        ></ModalVisualizarParcelasDeJob>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>